import HeroHomeTemplateFullBackground from './heroHomeTemplateFullBackground/heroHomeTemplate';
import HeroHomeTemplateDefault from './heroHomeTemplateDefault/heroHomeTemplate';

function HeroHomeTemplate({ type, ...rest }) {
  switch (type) {
    case 'Full Width Background Image':
      return <HeroHomeTemplateFullBackground {...rest} />;
    default:
      return <HeroHomeTemplateDefault {...rest} />;
  }
}

export default HeroHomeTemplate;
